import React from 'react';
import { TextField } from '@mui/material';
import {
  TreeList,
  mapFromTree,
  NodeMap,
  TreeNodeRef,
  checkboxStatus,
  TreeNode,
} from '@prismamedia/one-components';
import CollapsableListItem from '../ListItem/CollapsableListItem';
import { useStyles } from './styles';

export interface FilterListProps {
  withSearch?: boolean;
  onSearchChange?: (value: string) => void;
  onMoreClick?: (node: TreeNodeRef) => Promise<TreeNode[]>;
  searchClassName?: string;
  treeList: TreeNode[];
  timeout: 0 | 'auto';
  onChange?: (param: any, ids?: string[]) => void;
  title: string;
  field: string;
}

let internalTimeout: number;
const FilterList: React.FC<FilterListProps> = ({
  withSearch = false,
  onSearchChange,
  onMoreClick,
  searchClassName,
  timeout,
  treeList,
  onChange,
  title,
  field,
}) => {
  const [nodeMap, setNodeMap] = React.useState(mapFromTree(treeList, true));
  const classes = useStyles();
  return (
    <CollapsableListItem title={title}>
      {withSearch && (
        <div className={classes.searchContainer}>
          <TextField
            variant="standard"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              disableUnderline: true,
            }}
            className={searchClassName}
            placeholder="Rechercher ici"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onSearchChange && onSearchChange(event.target.value)
            }
          />
        </div>
      )}
      <TreeList
        nodeMap={nodeMap}
        onChange={(newNodeMap) => {
          setNodeMap(newNodeMap);
        }}
        onNodeCheck={async (checkedNode: TreeNodeRef, nodeMapChecked: NodeMap) => {
          const checkedIds = Object.values(nodeMapChecked)
            .filter((node) => node.checked === checkboxStatus.checked)
            .map((node) => node.id);
          // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/21310#issuecomment-367919251
          window.clearTimeout(internalTimeout);
          internalTimeout = window.setTimeout(async () => {
            if (onChange) {
              onChange(field, checkedIds);
            }
            // tslint:disable-next-line
          }, 1000);
        }}
        onMoreClick={onMoreClick}
        timeout={timeout}
      />
    </CollapsableListItem>
  );
};

// eslint-disable-next-line import/no-default-export
export default FilterList;
